var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuickReply = function SvgQuickReply(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M3.8 1h19.4C24.746 1 26 2.254 26 3.8v12.821c0 1.546-1.254 2.8-2.8 2.8h-6.41 0l-3.483 3.414-3.096-3.414H3.8c-1.546 0-2.8-1.254-2.8-2.8V3.8C1 2.254 2.254 1 3.8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.252 10.122c-.242.294-.127.533.247.533h2.956l-.813 4.849 4.576-5.594c.241-.294.125-.533-.251-.533h-2.97l.847-4.849-4.592 5.594z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuickReply);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/quick-reply.847ab36be17f59fdd7a7377906c6965f.svg";